export default __webpack_public_path__ + "static/how-we-do-it-8997d61fa9f5952297c0ef0262ca8eb8.svg";